import { useQuery } from "@apollo/client";

import { GET_TEMPLATE } from "./gql";

const useTemplate = (templateId?: string) => {
  return useQuery(GET_TEMPLATE, {
    variables: {
      id: templateId!,
    },
    // APOLLO CLIENT UPDATE
    nextFetchPolicy: "cache-first",
  });
};

export default useTemplate;
